<div class="p-3 subscription-manager">
	<h3 class="fw-bold mb-3">Suscripciones</h3>

	<div *ngIf="!client_user_id" class="alert alert-warning">
		Seleccione un cliente para ver y vender suscripciones.
	</div>

	<ng-container *ngIf="client_user_id">
		<div class="d-flex justify-content-between align-items-center mb-2">
			<h5 class="mb-0">Activas del cliente ({{subscription_list.length}})</h5>
			<button type="button" class="btn btn-primary btn-sm" (click)="startCreate()">Nueva suscripción</button>
		</div>

		<div *ngIf="subscription_items_in_order.length" class="alert alert-info">
			<div class="fw-bold mb-1">Artículos de suscripción en la orden:</div>
			<div *ngFor="let oii of subscription_items_in_order" class="d-flex justify-content-between align-items-center mb-1">
				<span>{{oii.item.name}} ({{oii.order_item.qty | number}})</span>
				<button type="button" class="btn btn-success btn-sm" (click)="startCreate(oii)">Crear suscripción</button>
			</div>
		</div>

		<div *ngIf="show_create_form" class="card p-2 mb-2">
			<h5>Nueva suscripción</h5>
			<div class="row">
				<div class="col-3 mb-2">
					<label>Categoría</label>
					<select class="form-control" [(ngModel)]="subscription_category_id" name="subscription_category_id">
						<option [ngValue]="null">Todas</option>
						<option *ngFor="let category of subscriptionCategories" [ngValue]="category.id">{{category.name}}</option>
					</select>
				</div>
				<div class="col-3 mb-2">
					<label>Artículo de suscripción<span *ngIf="new_subscription.item_id">: {{getSubscriptionItemName(new_subscription.item_id)}}</span></label>
					<select class="form-control" [(ngModel)]="new_subscription.item_id" (ngModelChange)="onSubscriptionItemChange()" name="subscription_item_id">
						<option [ngValue]="null">Seleccionar artículo…</option>
						<option *ngFor="let entry of filteredSubscriptionItems" [ngValue]="entry.item.id">{{entry.item.name}}</option>
					</select>
				</div>
				<ng-container *ngIf="asset_item_id">
					<div class="col-12 mb-1">
						<span class="badge bg-info">Renta {{getAssetItemName(asset_item_id)}} — elija cuarto o deje en pool para asignar en check-in</span>
					</div>
					<div class="col-6 mb-2">
						<label>Cuarto de {{getAssetItemName(asset_item_id)}} (vacío = se asigna solo el primero libre)</label>
						<select class="form-control" [(ngModel)]="new_subscription.serial_id" name="subscription_serial_id">
							<option [ngValue]="null">Automático (primer cuarto libre)</option>
							<option *ngFor="let serial of available_serials" [ngValue]="serial.id">{{getSerialLabel(serial)}}</option>
						</select>
					</div>
					<div class="col-12 mb-2 form-check">
						<input #poolCheckbox type="checkbox" class="form-check-input" [checked]="leave_in_pool" (change)="leave_in_pool = poolCheckbox.checked" name="subscription_pool" id="subscription_pool">
						<label class="form-check-label" for="subscription_pool">Dejar en pool (asignar cuarto después en check-in)</label>
					</div>
					<div class="col-6 mb-2 d-flex align-items-end">
						<button type="button" class="btn btn-secondary btn-sm" (click)="loadAvailableSerials()" *ngIf="!available_serials.length">Ver cuartos libres</button>
						<span class="small text-muted ms-2" *ngIf="available_serials.length">{{available_serials.length}} cuarto(s) libre(s)</span>
					</div>
				</ng-container>
				<ng-container *ngIf="!asset_item_id">
					<div class="col-3 mb-2">
						<label>Código de activo (ej. ROOM-101)</label>
						<input type="text" class="form-control" [(ngModel)]="new_subscription.asset_code" name="subscription_asset_code" placeholder="Vacío = pool">
					</div>
					<div class="col-3 mb-2">
						<label>O tipo de activo (si la tarifa no lo trae)</label>
						<select class="form-control" [(ngModel)]="asset_item_id" name="subscription_asset_item_id">
							<option [ngValue]="null">Sin tipo…</option>
							<option *ngFor="let entry of asset_item_list" [ngValue]="entry.item.id">{{entry.item.name}}</option>
						</select>
					</div>
				</ng-container>
				<div class="col-6 mb-2">
					<label>Inicia (vacío = ahora)</label>
					<input type="datetime-local" class="form-control" [(ngModel)]="new_subscription.starts_at" name="subscription_starts_at">
				</div>
				<div class="col-6 mb-2">
					<label>Entrega programada (opcional)</label>
					<input type="datetime-local" class="form-control" [(ngModel)]="new_subscription.scheduled_delivery" name="subscription_scheduled_delivery">
				</div>
				<div class="col-6 mb-2">
					<label>Devolución programada (opcional)</label>
					<input type="datetime-local" class="form-control" [(ngModel)]="new_subscription.scheduled_return" name="subscription_scheduled_return">
				</div>
				<div class="col-6 mb-2">
					<label>Quota total (vacío = solo tiempo)</label>
					<input type="number" class="form-control" [(ngModel)]="new_subscription.total_qty" name="subscription_total_qty" min="0">
				</div>
				<div class="col-12 mb-2 form-check">
					<input #returnableCheckbox type="checkbox" class="form-check-input" [checked]="new_subscription.is_returnable == 1" (change)="new_subscription.is_returnable = returnableCheckbox.checked ? 1 : 0" name="subscription_returnable" id="subscription_returnable">
					<label class="form-check-label" for="subscription_returnable">Requiere devolución física</label>
				</div>
				<div class="col-12 mb-2">
					<label>Nota</label>
					<input type="text" class="form-control" [(ngModel)]="new_subscription.note" name="subscription_note">
				</div>
			</div>
			<div *ngIf="availability" class="alert" [ngClass]="{'alert-success': (availability.asset_available !== false && availability.serial_available !== false && (availability.pool?.available_capacity == null || availability.pool.available_capacity > 0)), 'alert-danger': (availability.asset_available === false || availability.serial_available === false || (availability.pool?.available_capacity != null && availability.pool.available_capacity <= 0))}">
				<div *ngIf="availability.asset_code">Activo {{availability.asset_code}}: {{availability.asset_available ? 'disponible' : 'OCUPADO'}}</div>
				<div *ngIf="availability.serial_id">Serial #{{availability.serial_id}}: {{availability.serial_available ? 'disponible' : 'OCUPADO'}}<span *ngIf="availability.serial_available === false && availability.next_free_at"> — libre desde {{availability.next_free_at}}</span></div>
				<div *ngIf="availability.available_serials?.length"><span *ngIf="asset_item_id">{{getAssetItemName(asset_item_id)}} libres: </span><span *ngIf="!asset_item_id">Libres: </span><span *ngFor="let serial of availability.available_serials; let last = last">{{serial.serial_number}}{{last ? '' : ', '}}</span></div>
				<div *ngIf="availability.pool">Pool: {{availability.pool.available_capacity}} de {{availability.pool.pool_capacity}} disponibles</div>
				<div *ngIf="availability.rooms?.length">
					<div *ngFor="let room of availability.rooms" class="small">
						<span class="fw-bold">{{room.serial_number}}</span>:
						<span *ngIf="room.free" class="text-success">libre</span>
						<span *ngIf="!room.free">
							<span *ngFor="let holder of room.holders; let last = last">{{holder.holder_name || 'Ocupado'}} hasta {{holder.held_until}}{{last ? '' : '; '}}</span>
						</span>
					</div>
				</div>
				<div class="small">Vigencia calculada: {{availability.starts_at}} → {{availability.expires_at}}</div>
			</div>
			<div class="text-end">
				<button type="button" class="btn btn-secondary me-2" (click)="checkAvailability()">Verificar disponibilidad</button>
				<button type="button" class="btn btn-secondary me-2" (click)="loadAvailableSerials()" *ngIf="asset_item_id">Listar activos libres</button>
				<button type="button" class="btn btn-secondary me-2" (click)="show_create_form=false">Cancelar</button>
				<button type="button" class="btn btn-success" (click)="createSubscription()">Guardar</button>
			</div>
		</div>

		<div *ngIf="!subscription_list.length" class="text-muted">Sin suscripciones para este cliente.</div>

		<div *ngFor="let info of subscription_list" class="card mb-2 p-2">
			<div class="d-flex justify-content-between align-items-center" (click)="toggleExpanded(info.subscription.id)" style="cursor:pointer">
				<div>
					<span class="fw-bold">{{getItemName(info)}}</span>
					<span class="badge ms-2" [ngClass]="{'bg-success': getSubscriptionStatus(info)=='ACTIVE', 'bg-secondary': getSubscriptionStatus(info)!='ACTIVE'}">{{getSubscriptionStatus(info)}}</span>
					<span *ngIf="info.subscription.asset_code" class="badge bg-info ms-1">{{info.subscription.asset_code}}</span>
				</div>
				<div class="small text-muted">{{info.subscription.starts_at}} → {{info.subscription.expires_at || 'sin expiración'}}</div>
			</div>
			<div *ngIf="expanded_id == info.subscription.id" class="mt-2">
				<div *ngIf="info.subscription.balance_qty != null" class="mb-2">
					Saldo: <span class="fw-bold">{{info.subscription.balance_qty}}</span> de {{info.subscription.total_qty}}
					<div class="d-flex mt-1">
						<input type="number" class="form-control form-control-sm me-2" style="max-width:100px" [(ngModel)]="consume_quantities[info.subscription.id]" [ngModelOptions]="{standalone:true}" min="1" placeholder="1">
						<button type="button" class="btn btn-primary btn-sm" (click)="consume(info)" [disabled]="getSubscriptionStatus(info)!='ACTIVE'">Registrar uso</button>
					</div>
				</div>
				<div class="small text-muted mb-2" *ngIf="info.subscription.is_returnable">Retornable: {{info.subscription.returned_at ? 'devuelto el ' + info.subscription.returned_at : 'pendiente de devolución'}}</div>
				<div *ngIf="needsRoom(info)" class="card p-2 mb-2 bg-light">
					<div class="fw-bold mb-1">Check-in: asignar cuarto<span *ngIf="info.item?.asset_item_id"> ({{getAssetItemName(info.item.asset_item_id)}})</span></div>
					<div class="d-flex">
						<button type="button" class="btn btn-secondary btn-sm me-2" (click)="loadCheckinSerials(info)" *ngIf="!checkin_serials[info.subscription.id]">Ver cuartos libres</button>
						<ng-container *ngIf="checkin_serials[info.subscription.id]">
							<select class="form-control form-control-sm me-2" [(ngModel)]="assign_serial_ids[info.subscription.id]" [ngModelOptions]="{standalone:true}">
								<option [ngValue]="null">Seleccionar cuarto…</option>
								<option *ngFor="let serial of checkin_serials[info.subscription.id]" [ngValue]="serial.id">{{getSerialLabel(serial)}}</option>
							</select>
							<button type="button" class="btn btn-success btn-sm" (click)="assignSerial(info)">Asignar</button>
						</ng-container>
					</div>
				</div>
				<div class="small text-muted mb-2" *ngIf="info.subscription.serial_id">Cuarto asignado: <span class="fw-bold">{{info.subscription.asset_code}}</span></div>
				<div class="text-end">
					<button type="button" class="btn btn-success btn-sm me-1" (click)="renew(info)" *ngIf="info.subscription.expires_at">Renovar</button>
					<button type="button" class="btn btn-warning btn-sm me-1" (click)="returnAsset(info)" *ngIf="info.subscription.is_returnable && !info.subscription.returned_at">Devolver</button>
					<button type="button" class="btn btn-secondary btn-sm me-1" (click)="changeStatus(info, 'SUSPENDED')" *ngIf="info.subscription.status=='ACTIVE'">Suspender</button>
					<button type="button" class="btn btn-secondary btn-sm me-1" (click)="changeStatus(info, 'ACTIVE')" *ngIf="info.subscription.status=='SUSPENDED'">Reactivar</button>
					<button type="button" class="btn btn-danger btn-sm" (click)="changeStatus(info, 'CANCELLED')" *ngIf="info.subscription.status=='ACTIVE' || info.subscription.status=='SUSPENDED'">Cancelar</button>
				</div>
			</div>
		</div>
	</ng-container>
</div>
